import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    imports: [TranslateModule],
    selector: 'app-unauthorized',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './unauthorized.component.html'
})
export class UnauthorizedComponent {}
